










import Vue from 'vue'
import OwnerTable from '@/components/molecules/StoreOwners/List/OwnerTable.vue'
import RegisterUrl from '@/components/molecules/StoreOwners/List/RegisterUrl.vue'

export default Vue.extend({
  name: 'StoreOwnerList',
  components: { OwnerTable, RegisterUrl },
  props: {
    partnerId: {
      type: String,
      required: true,
    },
  },
})
